<template>
  <b-modal
    size="md"
    :style="{ zIndex: 200 }"
    v-model="isVisible"
    class="modal"
    :modal-class="isLoading ? 'loading' : ''"
    hide-footer
    no-close-on-backdrop
    centered
  >
    <template v-slot:modal-header="{ cancel }">
      <h5 class="modal-title">Save Partner Telegram Campaign</h5>
      <button
        type="button"
        aria-label="Close"
        class="close"
        @click.prevent="cancel"
      >
        <span class="material-icons"> close </span>
      </button>
    </template>
    <FormGenerator
      ref="form"
      :data="form"
      :isLoading="isLoading"
      @submit="submit"
    >
      <template v-slot:Partners="slotProps">
        <div class="row">
          <div class="col d-inline ">
            <div class="row">Chosen partners</div>
            <div class="row">
              <b-form-group class="col-1">
                <b-form-checkbox
                  size="md"
                  switch
                  v-model="slotProps.fields.partners.forAll"
                  class="switch"
                  :value="true"
                >All</b-form-checkbox>
              </b-form-group>
              <b-form-group v-if="!slotProps.fields.partners.forAll" class="col-11">
                <multiselect
                  v-model="slotProps.fields.partners.values"
                  :options="slotProps.fields.partners.options"
                  track-by="partnerId"
                  label="name"
                  :multiple="true">
                </multiselect>
              </b-form-group>
            </div>
          </div>
        </div>
      </template>
    </FormGenerator>
    <template v-slot:modal-footer="{ cancel }">
      <b-button variant="outline" class="button" @click.prevent="cancel">
        Cancel
      </b-button>
      <b-button variant="primary" class="button" @click.prevent="submitModal">
        Edit
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import FormGenerator from '@components/FormGenerator'
import TelegramPartnersMixin from '@mixins/notifications/TelegramPartnersMixin'

export default {
  components: {
    FormGenerator
  },
  mixins: [TelegramPartnersMixin],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    submit (data) {
      this.$emit('save', data)
    },
    submitModal () {
      this.$refs.form.submit()
    }
  }
}
</script>
